var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.214,
    height: 21.214,
    viewBox: "0 0 21.214 21.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-11.545 -12.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M28.639,13.478l-6.485,6.485-6.486-6.486A2.417,2.417,0,0,0,12.25,16.9l6.486,6.486-6.485,6.485a2.413,2.413,0,0,0,3.413,3.412l6.484-6.485,6.489,6.488a2.417,2.417,0,0,0,3.419-3.418l-6.489-6.488,6.484-6.485a2.413,2.413,0,0,0-3.412-3.412",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M28.639,13.478l-6.485,6.485-6.486-6.486A2.417,2.417,0,0,0,12.25,16.9l6.486,6.486-6.485,6.485a2.413,2.413,0,0,0,3.413,3.412l6.484-6.485,6.489,6.488a2.417,2.417,0,0,0,3.419-3.418l-6.489-6.488,6.484-6.485a2.413,2.413,0,0,0-3.412-3.412",
    fill: "#d51a66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ac1fa3ca322acfdc7cfb0bdfeb98ce8d.svg";
export { ForwardRef as ReactComponent };